<template>

  <div class="modal" tabindex="-1" role="dialog" id="modalcitocorreo">
    <div class="modal-dialog" role="document" style="min-width:1280px">
      <div class="modal-content" style="width:1320px">
        <div class="modal-header">
          <h5 class="modal-title text-center"> <b> Certificado {{name}} </b> </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span aria-hidden="true">&times;</span> </button>
        </div>
        <div class="modal-body text-center">
          <p v-show="cargando" class="text-center text-primary">Cargando datos...</p>
          <canvas id="myCanvas" width="1280" height="908" style="border:1px solid #55d3d3d3;">
          </canvas>
          <p v-show="cargando" class="text-center text-primary">Cargando datos...</p>

          <button :disabled="cargando" class="btn btn-sm btn-success" @click="guardar()"> Descargar certificado </button>
          <button :disabled="cargando" style="mrgin-left:8px" class="btn btn-sm btn-link" @click="enviarPorCorreo()"> Enviar Por Correo </button>
          <a href="" id="link"></a>
          <div id="qrcode"></div>
        </div>

        
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import gql from 'graphql-tag'
import { getCleanedString } from '@/components/Utils.js'

export default {
  props:{ model:{type:Object,required:true},correo:{type:Object,required:true} },
  data(){
    return{
      //correo: {xid:-1,xtitle:'X',xbody:'X',all:false,isDefault:false,xsql:null},
      cargando: false,
      image: null,
      qrLeft: null,
      qrRight: null,
      ctx: null,
      tam: 110,
      name: process.env.VUE_APP_NAME
    }
  },
  components: { },
  watch:{
    'model.inscripcion':function(){
      this.cargarQRleft( 'sha' ); // no llamar, llamamr despues de obtener el sha
      this.cargarQRRight();
      this.cargando = true;
      if( this.model.inscripcion.certificado_id ){
        this.getServerGenerado( this.model.inscripcion.certificado_id )
      }else{
        this.getDatosServer()
      }
    }
  },
  methods:{
    parseEst(){
      if( !this.model.inscripcion ) return "NUL"
      var es = this.model.inscripcion.estudiante;
      if( !es ) return "NULO"
      var am = es.seg_apellido?es.seg_apellido:"";
      return es.nombres+" "+es.pri_apellido+" "+am;
    },
    parseCargaHoraria(){
      if( this.model.inscripcion == null ) return "1";
      if( this.model.inscripcion.programa == null ) return "2";
      if( this.model.inscripcion.programa.postgrado == null ) return "3";
      var post = this.model.inscripcion.programa.postgrado;
      return post.carga_horaria;
    },
    parseSedeCiudad(){
      if( this.model.inscripcion == null ) return "1";
      if( this.model.inscripcion.programa == null ) return "2";
      if( this.model.inscripcion.programa.sede == null ) return "3";
      var sede = this.model.inscripcion.programa.sede.ciudad;
      return sede.nombre;
    },
    parseProgram(){
      if( this.model.inscripcion == null ) return "1";
      if( this.model.inscripcion.programa == null ) return "2";
      if( this.model.inscripcion.programa.postgrado == null ) return "3";
      var post = this.model.inscripcion.programa.postgrado;
      var nom = post.nombre.toUpperCase();
      nom = nom.replace("CURSO EN","")
      nom = nom.replace("CURSO ","")
      nom = nom.replace("CURSO ","")
      nom = nom.replace("CURSO EN","")
      nom = nom.replace("DIPLOMADO ","")
      nom = nom.replace("DIPLOMADO EN ","")
      nom = nom.replace("ESPECIALIDAD ","")
      nom = nom.replace("ESPECIALIDAD EN ","")
      nom = nom.replace("MAESTRIA EN ","")
      nom = nom.replace("MAESTRIA ","")
      return nom;
    },
    parseProgramQr( sha ){
      var idest = this.model.inscripcion.estudiante.num_doc;
      var str = process.env.VUE_APP_URL_VALIDATOR+"?idestudiante="+idest+"&idprograma="+sha;
      return str;
    },
    parseEstudiante(){
      if( this.model.inscripcion == null ) return "1";
      if( this.model.inscripcion.estudiante == null ) return "2";
      var es = this.model.inscripcion.estudiante;
      var pro = this.model.inscripcion.programa;
      if( es.seg_apellido == null ) es.seg_apellido = ""
      if( pro == null ) pro = {postgrado:{categoria:{}}};
      var post = pro.postgrado;
      var pnom = (post.nombre).toUpperCase();
      pnom = pnom.replace( "CURSO CURSO","CURSO " );

      var str = "DATOS DEL PARTICIPANTE:\n\n"
      str += "Estudiante: "+es.nombres+" "+es.pri_apellido+" "+es.seg_apellido+"\n"
      //str += "Correo: ---\n"
      str += "Usuario Moodle: "+es.usuario_moodle+"\n"
      //str += "Clave Moodle: ------\n\n"
      //str += "\nCURSO O PROGRAMA:\n"
      str += "\n\n"+pnom
      str += "\n\nRealizado del "+this.parseFecha(pro.fecha_inicio)+" AL "+this.parseFecha(pro.fecha_fin);
      return str;
    },
    parseMes( m ){
      m = m-1;
      if( m == 0 ) return "Enero"
      else if( m == 1 ) return "Febrero"
      else if( m == 2 ) return "Marzo"
      else if( m == 3 ) return "Abril"
      else if( m == 4 ) return "Mayo"
      else if( m == 5 ) return "Junio"
      else if( m == 6 ) return "Julio"
      else if( m == 7 ) return "Agosto"
      else if( m == 8 ) return "Septiembre"
      else if( m == 9 ) return "Octubre"
      else if( m == 10 ) return "Noviembre"
      else if( m == 11 ) return "Diciembre"
    },
    parseFecha( f ){
      if( f == null ) return "";
      var fs = f.split('-');
      return fs[2]+"/"+fs[1]+"/"+fs[0];
    },

    getDatosServer(){
      var estudiante = this.parseEst();
      var pp = this.parseProgram(); 
      var carguita = this.parseCargaHoraria();
      if( carguita == 0 ) carguita = 1;
      var pro = this.model.inscripcion.programa;
      var date = new Date();
      var dia = date.getDate();
      var mes = date.getMonth()+1;
      //var year = date.getFullYear()
      var diastr = dia;
      var messss = mes;
      if( diastr < 10 ) diastr = '0'+diastr;
      if( messss < 10 ) messss = '0'+messss;

      var datos = {};
      datos.curso = pp.trim(); 
      datos.emisor = this.model.universidad.nombre.toUpperCase();
      datos.lugar = this.model.inscripcion.programa.sede.ciudad.nombre.toUpperCase();
      datos.carga_horaria = carguita;
      datos.fecha_inicio = pro.fecha_inicio;
      datos.fecha_fin = pro.fecha_fin;
      //datos.fecha_registro = year+'-'+messss+'-'+diastr;
      datos.imagen_fondo = "sigloxx";
      datos.estudiantes = [ {inscripcion_id:this.model.inscripcion.id,estudiante:estudiante.toUpperCase()} ];

      window.console.log( "DATOSSS: ",window.stringifyObject(datos) )
      this.getServerDataCert( datos );
    },

    getServerDataCert( datos ){ 
      var sql = gql`mutation{ generarCertificados(input:${window.stringifyObject(datos)}){ ok certificados{inscripcion_id id codigo nro} errors{message} } }`;
      window.console.log( "GET CERTIFICADO",sql )
      this.$apollo.query({
        query: sql,
      }).then((data) => {
        var datos = data.data.generarCertificados;
        this.model.inscripcion.certificado_id = datos.certificados[0].id;
        window.console.log( "DATOS DEL SERVER: ",window.stringifyObject(datos) )
        window.console.log( "DATOS INSC : ",this.model.inscripcion )
        var vue = this;
        this.cargarQRleft( datos.certificados[0].codigo ); //aqui debe ir el sha
        setTimeout( function(){
          vue.cargarCanvas()
          vue.ctx.drawImage(vue.qrLeft, 90, 760, vue.tam, vue.tam);
          vue.ctx.drawImage(vue.qrRight, 1075, 760, vue.tam, vue.tam);
          vue.mostrarNumeroCert( datos.certificados[0] );
          vue.cargando = false;
        },1000)

      }).catch((error) => {
        this.msg = error;
        window.console.error(error)
      })
    },
    
    getServerGenerado( idcert ){ 
      var sql = gql`
      query{
        getCertificadoById(id:${idcert}){
          id
          nro
          curso
          codigo
          estudiante
          emisor
          lugar
          carga_horaria
          fecha_inicio
          fecha_fin
          fecha_registro
          imagen_fondo
          estado
        }
      }
      `;
      window.console.log( "GET CERTIFICADO",sql )
      this.$apollo.query({
        query: sql,
      }).then((data) => {
        var datos = data.data.getCertificadoById;
        window.console.log( window.stringifyObject(datos) )
        var vue = this;
        this.cargarQRleft( datos.codigo ); 
        setTimeout( function(){
          vue.cargarCanvas2( datos )
          vue.ctx.drawImage(vue.qrLeft, 90, 760, vue.tam, vue.tam);
          vue.ctx.drawImage(vue.qrRight, 1075, 760, vue.tam, vue.tam);
          vue.mostrarNumeroCert( datos );
          vue.cargando = false;
        },1000)

      }).catch((error) => {
        this.msg = error;
        window.console.error(error)
      })
    },

    mostrarNumeroCert( datos ){
      var c = document.getElementById("myCanvas");
      this.ctx.fillStyle = "#eeffff"
      this.ctx.font = "14px Arial";
      this.ctx.fillText("0000000000"+datos.nro, (c.width/2)+550, 20);
      this.ctx.fillStyle = "#000000"
    },
    

    cargarCanvas(){
      var estudiante = this.parseEst();
      var c = document.getElementById("myCanvas");

      var date = new Date();
      var dia = date.getDate();
      var mes = date.getMonth()+1;
      var messtr = this.parseMes( mes )
      var year = date.getFullYear()
      var diastr = dia;
      var messss = mes;
      if( diastr < 10 ) diastr = '0'+diastr;
      if( messss < 10 ) messss = '0'+messss;

      this.ctx.clearRect(0, 0, c.width, c.height);
      this.ctx.drawImage(this.image, 0, 0, 1280, 908);


      this.ctx.font = "32px Arial";
      this.ctx.textAlign = "center";
      this.ctx.fillText(""+estudiante, c.width/2+50, 510);
      var pp = this.parseProgram();
      if( pp.length > 65 ){
        pp = this.wordWrapToStringList( pp,65 );
        window.console.log( pp )
        var tt=585;
        var vue = this;
        pp.forEach(function( e ){
          vue.ctx.font = "22px Arial";
          vue.ctx.fillText(""+e, c.width/2+50, tt);
          tt +=22;
        });
      }else{
        this.ctx.font = "28px Arial";
        this.ctx.fillText(""+pp, c.width/2+50, 590);
      }
      this.ctx.font = "23px Arial";
      this.ctx.fillText(""+this.parseCargaHoraria(), (c.width/2)-20, 640);
      this.ctx.fillText(""+this.parseSedeCiudad(), (c.width/2)-110, 678);
      this.ctx.fillText(""+dia, (c.width/2)+200, 678);
      this.ctx.fillText(""+messtr, (c.width/2)-80, 711);
      this.ctx.fillText(""+year, (c.width/2)+210, 711); 
    },
    wordWrapToStringList (text, maxLength) {
      var result = [], line = [];
      var length = 0;
      text.split(" ").forEach(function(word) {
          if ((length + word.length) >= maxLength) {
              result.push(line.join(" "));
              line = []; length = 0;
          }
          length += word.length + 1;
          line.push(word);
      });
      if (line.length > 0) {
          result.push(line.join(" "));
      }
      return result;
    },

    cargarCanvas2( certificado ){
      var c = document.getElementById("myCanvas");

      this.ctx.clearRect(0, 0, c.width, c.height);
      this.ctx.drawImage(this.image, 0, 0, 1280, 908);

      var times = certificado.fecha_registro.split('T')[0];
      var fecha = times;
      var ps = fecha.split('-');
      var dia = ps[2];
      var mes = ps[1];
      var anio = ps[0]; 
      var messtr = this.parseMes( mes )
      

      this.ctx.font = "32px Arial";
      this.ctx.textAlign = "center";
      this.ctx.fillText(""+certificado.estudiante, c.width/2+50, 510);
      var pp = certificado.curso;
      if( pp.length > 65 ){
        pp = this.wordWrapToStringList( pp,65 );
        window.console.log( pp )
        var tt=585;
        var vue = this;
        pp.forEach(function( e ){
          vue.ctx.font = "22px Arial";
          vue.ctx.fillText(""+e, c.width/2+50, tt);
          tt +=22;
        });
      }else{
        this.ctx.font = "28px Arial";
        this.ctx.fillText(""+pp, c.width/2+50, 590);
      }
      this.ctx.font = "23px Arial";
      this.ctx.fillText(""+certificado.carga_horaria, (c.width/2)-20, 640);
      this.ctx.fillText(""+certificado.lugar, (c.width/2)-110, 678);
      this.ctx.fillText(""+dia, (c.width/2)+200, 678);
      this.ctx.fillText(""+messtr, (c.width/2)-80, 711);
      this.ctx.fillText(""+anio, (c.width/2)+210, 711); 
    },
    
    getDatos(){
      var xins = sessionStorage.xxinscripcion;
      this.model.inscripcion =JSON.parse( xins );
      window.console.log( window.stringifyObject(this.model.inscripcion) )
      this.cargarCanvas();
    },
    cargarQRleft( sha ){
      var p = this.parseProgramQr( sha );

      var qr = new window.VanillaQR({
        url: p,
        width: 600,
        height: 600,
        colorLight: "#FFFFFF",
        colorDark: "#000000",
        toTable: false,
        ecclevel: 1,
        noBorder: true,
        borderSize: 4,
      });

      this.qrLeft = qr.toImage("png");
      qr.init();
    },
    cargarQRRight(){
      //if( this.qrRight ) return;
      var p = this.parseEstudiante();

      var qr = new window.VanillaQR({
        url: p,
        width: 600,
        height: 600,
        colorLight: "#FFFFFF",
        colorDark: "#000000",
        toTable: false,
        ecclevel: 1,
        noBorder: true,
        borderSize: 4,
      });

      this.qrRight = qr.toImage("png");
      qr.init();
    },
    guardar(){
      var canvas = document.getElementById("myCanvas");
      let width = canvas.width; 
      let height = canvas.height;
      var pdf;
      var nombre = this.parseEst();

      if(width > height){
        pdf = new window.jsPDF('l', 'px', [width, height]);
      }
      else{
        pdf = new window.jsPDF('p', 'px', [height, width]);
      }

      width = pdf.internal.pageSize.getWidth();
      height = pdf.internal.pageSize.getHeight();
      pdf.addImage(canvas, 'PNG', 0, 0,width,height);
      pdf.save( nombre+".pdf");
    },
    enviarPorCorreo(){
      window.$('#modalcertificado').modal('hide')
      var vue = this;
      var opt = {
        okText:"Enviar por correo",
        cancelText:"Cerrar",
        backdropClose:false,
        animation: 'bounce',
        loader: true, 
        type:"classic"
      }
      var message = {
        title: 'Enviar Certificado por correo.',
        body: 'Se enviara un correo al participante con el enlace para descargar su certificado.'
      };
      this.$dialog.confirm(message,opt)
        .then(function( dialog ) { 
          vue.subirPDFServer( dialog );
        })
        .catch(function() { 
          
        });
    },
    subirPDFServer( dialog ){
      var canvas = document.getElementById("myCanvas");
      let width = canvas.width; 
      let height = canvas.height;
      var pdf;
      var nombre = this.parseEst();
      nombre = getCleanedString( nombre )
      nombre = nombre.toLowerCase()+'_'+this.model.inscripcion.id+'.pdf';

      if(width > height){
        pdf = new window.jsPDF('l', 'px', [width, height]);
      }
      else{
        pdf = new window.jsPDF('p', 'px', [height, width]);
      }

      width = pdf.internal.pageSize.getWidth();
      height = pdf.internal.pageSize.getHeight();
      pdf.addImage(canvas, 'PNG', 0, 0,width,height);
      //pdf.save( nombre+".pdf");
      var arc = pdf.output( 'blob' );

      var formData = new FormData();
      formData.append('nombre', nombre );
      formData.append('file', arc );
      
      var vue = this;
      window.jQuery.support.cors = true;
      window.$.ajax({
        method: "POST",
        headers: {"credentials": "false"},
        url: `${process.env.VUE_APP_URL_WEBDATA}certificados.php`,
        data: formData,
        processData: false,
        contentType: false,
      }).done(function(data){
        window.console.log(data,"PDF?CUSTOM: ",nombre);
        dialog.close()
        vue.mostrarModalCorreo( data );
      }).catch(function(e){
        window.console.log( e )
        dialog.close()
      });
      
    },
    mostrarModalCorreo( data ){
      var ins = this.model.inscripcion;
      var est = ins.estudiante.nombres+' '+ins.estudiante.pri_apellido;
      let filePdf = process.env.VUE_APP_URL_CERTIFICADOS+data.file
      var link = `<p><a href="${filePdf}" download><b>Toca aqui para descargar tu certificado</b></a> </p>\n`;
      this.correo.xid = -1;
      this.correo.xtitle = 'Enviar Certificado al Estudiante';
      this.correo.xbody = '<p>Hola '+est+', a continuacion te enviamos el link del certificado para descargarlo en formato PDF:</p>\n\n'+link;
      this.correo.all = false;
      this.correo.isDefault = true;
      this.correo.xsql = null;
      this.correo.xcorreo = ins.estudiante.email;
      this.correo.xnombre = this.name+' Certificado';
      this.correo.xasunto = this.name+' Certificado PDF';
      window.console.log( ins );
      window.$('#modalc').modal('show')
    },
    modalExitoCorreo(){},
  },
  mounted(){
    this.image = new Image();
    this.image.src = "img/webina.png";
    var c = document.getElementById("myCanvas");
    this.ctx = c.getContext("2d");
    this.ctx.drawImage(this.image, 0, 0, 1280, 908);
  }
}
</script>

